<template>
  <hic-dialog :visible="visible" :title="tmpl.name" @close="close" width="65rem">
    <hic-print-simple v-if="tmpl.code" :tmpl-code="tmpl.code" :print-data="{}" hide-preview-btn hide-print-dlg-btn hide-print-btn hide-export-btn />
  </hic-dialog>
</template>
<script>
  export default {
    props: {
      value: Object,
      visible: Boolean,
    },
    computed: {
      tmpl() {
        if (this.value) {
          return this.value;
        }
        return {};
      },
    },
    methods: {
      close() {
        this.$emit("update:visible", false);
      },
    },
  };
</script>
